import { render, staticRenderFns } from "./postTest.vue?vue&type=template&id=3b2e11d6&scoped=true&"
import script from "./postTest.vue?vue&type=script&lang=js&"
export * from "./postTest.vue?vue&type=script&lang=js&"
import style0 from "./postTest.vue?vue&type=style&index=0&id=3b2e11d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e11d6",
  null
  
)

export default component.exports